class CaApiRequestParamDto {
  /** 接口编码 */
  apiCode = "";

  /** 业务单号 */
  businessNo = "";

  /** 接口参数 */
  data = undefined;

  /** 模块编码 */
  moduleCode = "";

  /** 交易主体编码 */
  transactionMainCode = "";
}

class CaApiResponseDto {
  /** data */
  data = undefined;
}

class EApiRecordRequestParamsDto {
  /** API编码 */
  apiCode = "";

  /** API名称 */
  apiName = "";

  /** 业务单号 */
  businessNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间-结束范围 */
  createTimeEnd = "";

  /** 创建时间-开始范围 */
  createTimeStart = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否启用 */
  enableFlag = false;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 模块名称 */
  moduleCode = "";

  /** 备注 */
  remark = "";

  /** 请求是否成功 */
  requestFlag = false;

  /** 日志链路ID */
  traceId = "";

  /** 交易主体编码 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 修改时间-结束范围 */
  updateTimeEnd = "";

  /** 修改时间-开始范围 */
  updateTimeStart = "";
}

class EApiRecordResponseDto {
  /** API编码 */
  apiCode = "";

  /** API名称 */
  apiName = "";

  /** 业务单号 */
  businessNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否启用 */
  enableFlag = false;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 模块名称 */
  moduleCode = "";

  /** 备注 */
  remark = "";

  /** 请求是否成功 */
  requestFlag = false;

  /** 日志链路ID */
  traceId = "";

  /** 交易主体编码 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class EApiRequestDto {
  /** API编码 */
  apiCode = "";

  /** API描述 */
  apiDesc = "";

  /** API请求方式 */
  apiMethod = "";

  /** API名称 */
  apiName = "";

  /** API请求地址 */
  apiUrl = "";

  /** 是否启用 */
  enableFlag = false;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 备注 */
  remark = "";

  /** 是否需要签名 */
  signFlag = false;
}

class EApiRequestParamsDto {
  /** API编码 */
  apiCode = "";

  /** API描述 */
  apiDesc = "";

  /** API请求方式 */
  apiMethod = "";

  /** API名称 */
  apiName = "";

  /** API请求地址 */
  apiUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间-结束范围 */
  createTimeEnd = "";

  /** 创建时间-开始范围 */
  createTimeStart = "";

  /** 是否启用 */
  enableFlag = false;

  /** id */
  id = undefined;

  /** 备注 */
  remark = "";

  /** 是否需要签名 */
  signFlag = false;

  /** 修改人 */
  updateBy = "";

  /** 修改时间-结束范围 */
  updateTimeEnd = "";

  /** 修改时间-开始范围 */
  updateTimeStart = "";
}

class EApiResponseDto {
  /** API编码 */
  apiCode = "";

  /** API描述 */
  apiDesc = "";

  /** API请求方式 */
  apiMethod = "";

  /** API名称 */
  apiName = "";

  /** API请求地址 */
  apiUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否启用 */
  enableFlag = false;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 备注 */
  remark = "";

  /** 是否需要签名 */
  signFlag = false;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class EChapterApiRelationResponseDto {
  /** API编号 */
  apiCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** echapterCode */
  echapterCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class EChapterDetailResponseDto {
  /** 调用电子章接口 */
  apiRelationList = [];

  /** appId */
  appId = "";

  /** appSecret */
  appSecret = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 开发平台账号 */
  devAccount = "";

  /** 开发平台密码 */
  devPassword = "";

  /** 对接人 */
  dockingCode = "";

  /** 对接人联系方式 */
  dockingPhone = "";

  /** echapterCode */
  echapterCode = "";

  /** 是否启用 */
  enableFlag = false;

  /** esealCode */
  esealCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 使用模块 */
  moduleRelationList = [];

  /** 负责人 */
  principalCode = "";

  /** 负责人联系方式 */
  principalPhone = "";

  /** 备注 */
  remark = "";

  /** 交易主体编码 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class EChapterEditRequestDto {
  /** 调用电子章接口 */
  apiCodeList = [];

  /** appId */
  appId = "";

  /** appSecret */
  appSecret = "";

  /** 开发平台账号 */
  devAccount = "";

  /** 开发平台密码 */
  devPassword = "";

  /** 对接人 */
  dockingCode = "";

  /** 对接人联系方式 */
  dockingPhone = "";

  /** echapterCode */
  echapterCode = "";

  /** 是否启用 */
  enableFlag = false;

  /** esealCode */
  esealCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 使用模块 */
  moduleCodeList = [];

  /** 负责人 */
  principalCode = "";

  /** 负责人联系方式 */
  principalPhone = "";

  /** 用途说明 */
  remark = "";

  /** 交易主体编码 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class EChapterModuleRelationResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** echapterCode */
  echapterCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 模块编号 */
  moduleCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class EChapterRequestDto {
  /** 调用电子章接口 */
  apiCodeList = [];

  /** appId */
  appId = "";

  /** appSecret */
  appSecret = "";

  /** 开发平台账号 */
  devAccount = "";

  /** 开发平台密码 */
  devPassword = "";

  /** 对接人 */
  dockingCode = "";

  /** 对接人联系方式 */
  dockingPhone = "";

  /** echapterCode */
  echapterCode = "";

  /** 是否启用 */
  enableFlag = false;

  /** esealCode */
  esealCode = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 使用模块 */
  moduleCodeList = [];

  /** 负责人 */
  principalCode = "";

  /** 负责人联系方式 */
  principalPhone = "";

  /** 用途说明 */
  remark = "";

  /** 交易主体编码 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class EChapterRequestParamsDto {
  /** appId */
  appId = "";

  /** appSecret */
  appSecret = "";

  /** 是否授权成功 */
  authFlag = false;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间-结束范围 */
  createTimeEnd = "";

  /** 创建时间-开始范围 */
  createTimeStart = "";

  /** 删除标识 */
  deleted = undefined;

  /** 开发平台账号 */
  devAccount = "";

  /** 开发平台密码 */
  devPassword = "";

  /** 对接人 */
  dockingCode = "";

  /** 对接人联系方式 */
  dockingPhone = "";

  /** echapterCode */
  echapterCode = "";

  /** 是否启用 */
  enableFlag = false;

  /** esealCode */
  esealCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 负责人 */
  principalCode = "";

  /** 负责人联系方式 */
  principalPhone = "";

  /** 备注 */
  remark = "";

  /** 交易主体编码 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 修改时间-结束范围 */
  updateTimeEnd = "";

  /** 修改时间-开始范围 */
  updateTimeStart = "";
}

class EChapterResponseDto {
  /** appId */
  appId = "";

  /** appSecret */
  appSecret = "";

  /** 是否授权成功 */
  authFlag = false;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 开发平台账号 */
  devAccount = "";

  /** 开发平台密码 */
  devPassword = "";

  /** 对接人 */
  dockingCode = "";

  /** 对接人联系方式 */
  dockingPhone = "";

  /** echapterCode */
  echapterCode = "";

  /** 是否启用 */
  enableFlag = false;

  /** esealCode */
  esealCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 负责人 */
  principalCode = "";

  /** 负责人联系方式 */
  principalPhone = "";

  /** 备注 */
  remark = "";

  /** 交易主体编码 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class ModuleInfoResponseDto {
  /** code */
  code = "";

  /** name */
  name = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new CaApiResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class TransactionMainResponseDto {
  /** addressAndPhone */
  addressAndPhone = "";

  /** bankAccountNumber */
  bankAccountNumber = "";

  /** taxNumber */
  taxNumber = "";

  /** taxRate */
  taxRate = undefined;

  /** transactionMainCode */
  transactionMainCode = "";

  /** transactionMainName */
  transactionMainName = "";

  /** transactionMainNsCode */
  transactionMainNsCode = "";
}

export const esca = {
  CaApiRequestParamDto,
  CaApiResponseDto,
  EApiRecordRequestParamsDto,
  EApiRecordResponseDto,
  EApiRequestDto,
  EApiRequestParamsDto,
  EApiResponseDto,
  EChapterApiRelationResponseDto,
  EChapterDetailResponseDto,
  EChapterEditRequestDto,
  EChapterModuleRelationResponseDto,
  EChapterRequestDto,
  EChapterRequestParamsDto,
  EChapterResponseDto,
  IPage,
  ModuleInfoResponseDto,
  Response,
  ResponseDto,
  TransactionMainResponseDto,
};
